import type { CancellationController } from '@/engine/Controllers/Cancellation.controller';
import { AngleToolFactory } from './angle/AngleTool.factory';
import { AnnotationToolFactory } from './annotation/AnnotationTool.factory';
import { AreaToolFactory } from './area/AreaTool.factory';
import { DistanceToolFactory } from './distance/DistanceTool.factory';
import type { IIndicationToolFactory } from './Indications.factory';
import type { IndicationsService } from './Indications.service';
import { SplineToolFactory } from './spline/SplineTool.factory';

import { Tools } from './ToolStateStore';

export class IndicationsRegistry {
  private _tool2IndicationFactoryMap: Map<Tools, IIndicationToolFactory> = new Map();

  private readonly _indicationsService: IndicationsService;

  private readonly _cancellationController: CancellationController;

  public constructor(indicationsService: IndicationsService, cancellationController: CancellationController) {
    this._indicationsService = indicationsService;
    this._cancellationController = cancellationController;

    this._tool2IndicationFactoryMap.set(
      Tools.Distance,
      new DistanceToolFactory(this._indicationsService, this._cancellationController)
    );

    this._tool2IndicationFactoryMap.set(Tools.Angle, new AngleToolFactory(this._indicationsService));

    this._tool2IndicationFactoryMap.set(Tools.Area, new AreaToolFactory(this._indicationsService));

    this._tool2IndicationFactoryMap.set(Tools.Spline, new SplineToolFactory(this._indicationsService));

    this._tool2IndicationFactoryMap.set(Tools.Annotation, new AnnotationToolFactory(this._indicationsService));
  }

  public getFactoryForTool(tool: Tools): IIndicationToolFactory {
    if (!this._tool2IndicationFactoryMap.has(tool)) {
      throw new Error('Tool is not registered');
    }
    return this._tool2IndicationFactoryMap.get(tool)!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
  }
}
